import { API_URL } from '../const';
import { makeApiCall } from '../_common/api.utils';

// export const getEmployeeListData = (data: any) => {
// 	const URL = `${API_URL}AllEmployeeDetails`;
// 	console.log(data);
// 	return makeApiCall(URL, data);
// };

export const getAllEmployeeListData = (data: any) => {
	const requestData = {
		GetAllEmployeeDetailsToken: data,
	};
	const URL = `${API_URL}GetAllEmployeeDetails`;
	console.log(data);
	return makeApiCall(URL, requestData);
};

export const fetchEmployeeDetailsBasedOnID = (data: { empID: string; databaseName: string }) => {
	const requestData = {
		fetchEmployeeDetailsBasedOnIDToken: data,
	};
	const URL = `${API_URL}GetEmployeeDetailsBasedOnID`;
	return makeApiCall(URL, requestData);
};

export const updateEmployeeDetails = (data: any) => {
	const requestData = {
		updateEmployeeDetailsToken: data,
	};
	const URL = `${API_URL}UpdateEmployeeDetailsBasedOnID`;
	return makeApiCall(URL, requestData);
};
